import { ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsModalService, DsModule } from '@levelaccess/design-system';

import { AccessibilityAuditToolNames } from '@shared/constants/audit-tool';
import { AuditTypes } from '@shared/constants/audit-types';
import { IIssueActionContext, IssueActionsService } from '@client/app/services/issue-finding-details/issue-actions.service';
import { CommonPipesModule } from '@client/app/shared/common-pipes.module';
import { SharedModule } from '@client/app/shared/shared.module';
import { TranslateService } from '@client/app/translate/translate.service';
import { ScanReportService } from '@client/app/services/scan-report.service';
import { NotificationService } from '@client/app/services/notification.service';
import { LoadErrorHandler } from '@client/app/services/load-error-handler';
import { A11yService } from '@client/app/services/a11y.service';
import { UserService } from '@client/app/services/user.service';
import { IssuesViewDetailsModalBaseComponent } from '@client/app/pages/public/scans/scan-results/issues-view-details-base/issues-view-details-modal-base.component';

@Component({
  selector: 'app-issues-view-details-modal',
  templateUrl: './issues-view-details-modal.component.html',
  styleUrl: '../../issues-view-details-base/finding-modal-header-actions.scss',
  imports: [DsModule, SharedModule, CommonPipesModule],
})
export class IssuesViewDetailsModalComponent extends IssuesViewDetailsModalBaseComponent {
  @Input() public toolName: AccessibilityAuditToolNames;
  @Input() public isDigitalAssetFindingsEnabled: boolean;
  @Input() public auditType: AuditTypes;
  @Input() public scanUrl: string;

  constructor(
    modal: NgbActiveModal,
    translateService: TranslateService,
    scanReportService: ScanReportService,
    dsModalService: DsModalService,
    notificationService: NotificationService,
    loadErrorHandler: LoadErrorHandler,
    issueActionsService: IssueActionsService,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef<HTMLElement>,
    a11yService: A11yService,
    userService: UserService,
  ) {
    super(
      modal,
      translateService,
      scanReportService,
      dsModalService,
      notificationService,
      loadErrorHandler,
      issueActionsService,
      changeDetectorRef,
      elementRef,
      a11yService,
      userService,
    );
  }

  protected get actionContext(): IIssueActionContext {
    return {
      auditType: this.auditType,
      ruleDetails: this.ruleDetails,
      scanId: this.scanId,
      scanUrl: this.scanUrl,
    };
  }

  protected get shareToolName(): AccessibilityAuditToolNames {
    return this.toolName;
  }
}
